module.exports = __webpack_public_path__ + "img/wx4.71df6a2c.jpg";